var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFirmwareUpgrade(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 361 376",
    style: {
      enableBackground: "new 0 0 361 376"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#43C9C9;}\n\t.st1{fill:#E022A6;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#E022A6;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "connect_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109.7,372.9c-5.5,0-10.5-1.2-14.8-4.9c-8-6.2-12.3-17.2-10.5-28.9c1.2-9.2,3.1-40-16-63.4 c-17.8-20.9-27.7-26.5-36.3-28.9c-8.6-3.1-18.5-10.5-19.7-23.4c-1.2-9.2,1.2-21.5,17.2-29.5c12.9-6.2,31.4-17.8,42.5-34.5 c16.6-24,14.2-52.9,12.9-60.9C83.9,88,87,78.1,94.3,72.6c9.8-7.4,23.4-7.4,33.8-0.6c11.7,8,35.1,21.5,56,21.5 c23.4,0,47.4-14.8,56.6-21.5c7.4-4.9,16-6.2,24.6-3.1h0.6c12.3,4.3,19.7,16,17.8,28.9c-1.8,17.2-2.5,42.5,12.3,62.2 c17.8,23.4,32.6,32,41.8,35.1c9.8,3.1,16.6,12.3,17.8,22.8c0.6,11.7-6.2,21.5-18.5,27.7c-14.2,6.8-31.4,16.6-43.1,35.7 c-14.8,25.2-12.9,52.3-11.7,62.8c1.2,9.2-3.1,18.5-10.5,23.4c-5.5,3.7-17.8,8.6-33.2-1.8c-1.2-0.6-2.5-1.8-3.7-2.5 c-4.9-3.1-10.5-7.4-17.2-9.8c-11.7-4.3-17.2-5.5-19.7-5.5c-6.2-0.6-11.1-4.3-13.5-10.5c0-0.6,0-0.6-0.6-0.6v0.6 c-1.2,3.1-4.3,9.2-14.8,10.5c-3.7,0-11.1,1.8-19.1,6.2c-6.2,2.5-12.3,6.8-20.9,12.9C123.3,370.4,116.5,372.9,109.7,372.9z  M113.5,90.9c-2.4,0-4.2,0.6-5.9,1.8l0,0c-1.8,1.2-2.4,4.2-1.8,7.7c1.2,9.5,4.2,42.7-15.4,71.2c-13.1,19-33.2,32-48.1,39.2 c-5.9,3-7.1,6.5-6.5,10.7c0.6,5.3,6.5,7.1,7.1,7.1c10.7,3.6,23.1,10.1,43.3,33.2c23.7,27.9,20.8,64.1,19.6,74.8 c-0.6,3-0.6,8.9,3.6,11.9c1.8,1.2,7.1,1.2,10.7-1.2c5.9-4.7,14.2-10.1,23.1-14.2c8.3-3.6,17.2-6.5,23.7-7.1c3-7.1,8.9-10.7,16-10.7 c7.1,0,13.7,4.2,16.6,11.3c5.3,0.6,13.1,3,22.6,6.5c8.3,3.6,15.4,7.7,20.2,11.3c1.2,0.6,2.4,1.2,3,2.4c6.5,4.2,10.7,3,13.1,1.8 c1.8-1.2,2.4-3,2.4-4.7c-1.8-11.9-3.6-42.7,13.1-71.8c13.1-22.6,33.2-34.4,49.3-41.5c5.3-2.4,8.3-5.9,7.7-9.5c0-3-2.4-5.3-4.7-6.5 c-11.3-3.6-29.1-13.7-48.7-39.8c-18.4-23.7-17.8-52.8-15.4-72.4c0.6-4.2-1.8-7.7-5.9-8.9l0,0c-2.4-2.4-5.9-2.4-8.3-0.6 c-12.5,8.9-38,23.7-64.7,23.7c-23.7,0-48.1-13.1-64.1-23.7C117.1,91.5,115.3,90.9,113.5,90.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "smile_8_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 133.1,
    cy: 170.4,
    r: 10.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 166.3,
    cy: 170.4,
    r: 10.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 199.6,
    cy: 170.4,
    r: 10.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 232.8,
    cy: 170.4,
    r: 10.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "smile_7_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 133.1,
    cy: 203,
    r: 10.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 166.3,
    cy: 203,
    r: 10.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 199.6,
    cy: 203,
    r: 10.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 232.8,
    cy: 203,
    r: 10.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "smile_6_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 133.1,
    cy: 235.7,
    r: 10.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 166.3,
    cy: 235.7,
    r: 10.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 199.6,
    cy: 235.7,
    r: 10.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 232.8,
    cy: 235.7,
    r: 10.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "smile_5_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 133.1,
    cy: 267.7,
    r: 10.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 166.3,
    cy: 267.7,
    r: 10.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 199.6,
    cy: 267.7,
    r: 10.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 232.8,
    cy: 267.7,
    r: 10.5
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1927 -934)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2163,966.5l-55.5,50.5l-55.5-50.5h27.8V934h55.5v32.5H2163z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirmwareUpgrade);
export default __webpack_public_path__ + "static/media/firmware-upgrade.527418a1656e9f228891abd5adaf5c12.svg";
export { ForwardRef as ReactComponent };